import React from "react";
import * as MUI from "@mui/material";
import { useTranslation } from "react-i18next";
import Span from "../../../../../components/display/Span";
import TextEditorViewer from "../../../../../components/display/TextEditorViewer";

// Was the dead singleView content viewer, now reused as the details
// dialog's body (TemplateDetailsDialog.jsx) - extended with a Categories
// row so the popup surfaces the same metadata the new TemplatesTable.jsx
// column does, the same way Services' details dialog mirrors its table.
export default function TemplateDetails({ template }) {
  const { t } = useTranslation();
  return (
    <MUI.Stack spacing={3}>
      <MUI.Stack spacing={2}>
        <Span
          variant="h5"
          sx={{ overflowWrap: "break-word", fontWeight: 700 }}
          text={template?.title}
        />
        {template?.category?.length > 0 && (
          <MUI.Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
            {template.category.map((category) => (
              <MUI.Chip key={category} label={t(category)} size="small" color="primary" />
            ))}
          </MUI.Stack>
        )}
        <MUI.Divider />
      </MUI.Stack>
      <TextEditorViewer value={template?.description} />
    </MUI.Stack>
  );
}
